import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Prompt, withRouter } from 'react-router-dom';
import * as Constants from 'constants/Constants';
import { SYSTEM_ADMIN } from 'constants/Constants';
import cs from 'classnames';
import baseCSS from 'components/FuelVendor/FuelVendor.module.css';
import classes from 'components/FuelVendor/FuelVendorDetails/FuelVendorDetail.module.css';
import Auxiliary from 'hoc/Auxiliary';
import Header from 'components/Header/Header';
import Styles from './FuelVendorDetail.module.css';
import {
    APP_BAR_THEME,
    FILLED_INPUT_FIELD_THEME,
    APP_BAR_THEME_ALT
} from 'components/FuelVendor/FuelVendorMuiTheme';
import AppBar from '@material-ui/core/AppBar/AppBar';
import * as actions from 'components/FuelVendor/store/actions/index';
import {
    Button,
    FilledInput,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    MuiThemeProvider,
    Paper,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography
} from '@material-ui/core';
import { PrimarySwitch } from '../../TrustCenter/TrustCenterMuiTheme';
import {
    DIALOG_THEME,
    FILLED_TEXTFIELD_THEME,
    INTEGRATION_OPTIONS_THEME
} from './FuelVendorDetailMuiTheme';
import {
    PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME,
    PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME,
    PRIMARY_BUTTON_LIGHT_NEGATIVE_THEME,
    PRIMARY_BUTTON_LIGHT_THEME
} from 'components/UI/Button/ButtonMuiTheme';
import BatchType from './BatchType/BatchType';
import InteractiveType from './InteractiveType/InteractiveType';
import { isBlank, isEmptyObject, isNotBlank } from 'components/Common/Utils/StringUtils';
import VendorNameSearch from './VendorNameSearch/VendorNameSearch';
import TDialog from '../../UI/Dialog/TDialog';
import CreateIcon from '@material-ui/icons/Create';
import Spinner from 'components/UI/Spinner/Spinner';
import validateFuelFields, { checkEmptyFields } from './Validation/FuelValidation';
import FormHelperText from '@material-ui/core/FormHelperText';
import { setCurrentPage } from 'store/actions';
import { validateWriteAccess } from 'components/Common/ResourceAccessValidation/ResourceAccessValidation';
import { event } from 'components/Common/Utils/ReactGa4Utils';

const FuelVendorDetails = (props) => {
    const {
        session,
        sidebarResource,
        fuelVendorAccount,
        getFuelVendorAccount,
        updateFuelAccount,
        isDuplicateFuelVendor,
        saveFuelVendor,
        toggleDuplicateCheck,
        createdFuelVendorID,
        updateCreatedFuelVendorId,
        toggleFuelDetailsLoaded,
        showSpinner,
        updateFuelVendor,
        toggleFuelVendorStatus,
        toggleSpinner,
        updatedFuelVendorAccount,
        discardFuelChanges,
        disableInteractiveField,
        toggleSaveButton,
        disableSaveButton,
        setCurrentPage,
        resetFuelVendorAccount,
        toggleEditDetails,
        editDetails,
        selectedAccount
    } = props;

    let isSystemAdmin = session.userRole === SYSTEM_ADMIN;
    const selectedFuelVendorId = props.match.params.id;
    const mode = props.match.params.mode;
    const [isWriteAccessGranted, setWriteAccessGranted] = useState(false);
    const initialFuelObject = {
        vendor_name: '',
        status: true,
        vendor_type: 'Batch',
        account_code: '',
        customer_code: '',
        user_name: '',
        password: '',
        integration_type: ''
    };

    const [fuelVendor, setFuelVendor] = useState(
        isEmptyObject(fuelVendorAccount) ? initialFuelObject : fuelVendorAccount
    );

    const [displayType, setDisplayType] = useState({
        batchType: true,
        interactive: false,
        comDataInteractive: false
    });

    const defErrorConfig = {
        isInvalid: false,
        message: ''
    };

    const [field, setFieldValidation] = useState({
        account_code: defErrorConfig,
        customer_code: defErrorConfig,
        user_name: defErrorConfig,
        password: defErrorConfig,
        integration_type: defErrorConfig
    });

    const MenuProps = {
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
        },
        getContentAnchorEl: null
    };

    const [openConfimation, setOpenConfimation] = useState(false);
    const [duplicateVendorText, setDuplicateVendorText] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [toggleEditFuelDetails, setToggleEditFuelDetails] = useState(false);
    const [disableSaveBtn, setDisableSaveBtn] = useState(true);

    useEffect(() => {
        setWriteAccessGranted(
            validateWriteAccess(
                sidebarResource,
                Constants.FUELVENDOR_RESOURCE,
                Constants.FUELVENDOR_FEATURE
            )
        );
    }, [sidebarResource]);

    useEffect(() => {
        setCurrentPage(Constants.FUEL_VENDOR_DETAILS);
        toggleEditDetails(false);
        resetFuelVendorAccount({});
    }, [setCurrentPage]);

    useEffect(() => {
        if (isWriteAccessGranted) {
            if (isNotBlank(mode) && mode === Constants.FUEL_EDIT_MODE) {
                setToggleEditFuelDetails(true);
            } else if (isBlank(selectedFuelVendorId)) {
                setToggleEditFuelDetails(true);
            }
        }
    }, [mode, isWriteAccessGranted]);

    useEffect(() => {
        if (isNotBlank(createdFuelVendorID)) {
            setToggleEditFuelDetails(false);
            props.history.push(`/fuelcard-details/${createdFuelVendorID}`);
            toggleSpinner(true);
            resetToDefaults();
        }
    }, [createdFuelVendorID]);

    useEffect(() => {
        discardFuelChanges(false);
        if (selectedFuelVendorId) {
            getFuelVendorAccount(selectedFuelVendorId);
        } else {
            setFuelVendor(initialFuelObject);
        }
    }, [getFuelVendorAccount]);

    useEffect(() => {
        setFuelVendor(fuelVendorAccount);
    }, [fuelVendorAccount]);

    useEffect(() => {
        if (isBlank(selectedFuelVendorId)) {
            setFuelVendor({
                ...fuelVendor,
                ...updatedFuelVendorAccount,
                vendor_name: updatedFuelVendorAccount.vendor_name,
                batch: updatedFuelVendorAccount.batch,
                interactive: updatedFuelVendorAccount.interactive
            });
        }
        discardFuelChanges(false);
        disableSave();
    }, [updatedFuelVendorAccount]);

    useEffect(() => {
        findTypesToDisplay(fuelVendor);
        disableSave();
        if (fuelVendorAccount.vendor_name) {
            toggleFuelDetailsLoaded(true);
        }
    }, [fuelVendor]);

    useEffect(() => {
        disableSave();
    }, [displayType]);

    useEffect(() => {
        if (disableInteractiveField && isBlank(selectedFuelVendorId)) {
            setFuelVendor({
                ...fuelVendor,
                vendor_type: Constants.FUEL_VENDOR_BATCH_TYPE
            });
        }
    }, [disableInteractiveField]);

    useEffect(() => {
        if (isDuplicateFuelVendor) {
            const message = (
                <Typography>
                    <label>
                        There is already a Fuel Card Partner with these settings in the system:
                        <br />
                        <br />
                        Vendor {fuelVendor.vendor_name}
                        <br />
                        Account code {fuelVendor.account_code}
                        <br />
                        Customer code {fuelVendor.customer_code}
                    </label>
                </Typography>
            );
            setDuplicateVendorText(message);
            setOpenConfimation(true);
            toggleEditDetails(true);
        } else {
            setOpenConfimation(false);
        }
    }, [isDuplicateFuelVendor]);

    const findTypesToDisplay = (vendor) => {
        let display = {};
        if (
            updatedFuelVendorAccount.vendor_name === 'Comdata' &&
            vendor.vendor_type === Constants.FUEL_VENDOR_INTERACTIVE_TYPE
        ) {
            display.comDataInteractive = true;
            display.batchType = false;
            display.interactive = false;
        } else if (
            updatedFuelVendorAccount.vendor_name !== 'Comdata' &&
            vendor.vendor_type === Constants.FUEL_VENDOR_INTERACTIVE_TYPE
        ) {
            display.comDataInteractive = false;
            display.batchType = false;
            display.interactive = true;
        } else if (vendor.vendor_type === Constants.FUEL_VENDOR_BATCH_TYPE) {
            display.comDataInteractive = false;
            display.batchType = true;
            display.interactive = false;
        }
        setDisplayType(display);
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'status') {
            setFuelVendor({ ...fuelVendor, [name]: event.target.checked });
            setToggleEditFuelDetails(false);
            toggleFuelVendorStatus([fuelVendor.id], event.target.checked);
        } else {
            toggleEditDetails(true);
            validateFields(event);
            setFuelVendor({ ...fuelVendor, [name]: value });
        }
        disableSave();
    };

    const validateFields = (event) => {
        const { name } = event.target;
        const result = validateFuelFields(event);
        setFieldValidation({ ...field, [name]: result });
        if (result.invalid) {
            toggleSaveButton(true);
        } else {
            toggleSaveButton(false);
        }
    };

    const handleSave = () => {
        event('FuelCardPartners', 'FuelCardPartnersUpdated', `${session.accountName}`);
        toggleEditDetails(false);
        if (isBlank(fuelVendor.id)) {
            let fuelSaveObject = { ...fuelVendor, ...updatedFuelVendorAccount };
            if (fuelVendor.vendor_type === Constants.FUEL_VENDOR_BATCH_TYPE) {
                fuelSaveObject.interactive = null;
                fuelSaveObject.integration_type = '';
            } else if (fuelVendor.vendor_type === Constants.FUEL_VENDOR_INTERACTIVE_TYPE) {
                fuelSaveObject.batch = null;
            }
            setFuelVendor(fuelSaveObject);
            saveFuelVendor(fuelSaveObject);
        } else {
            let fuelUpdateObject = {
                ...fuelVendor,
                vendor_name: updatedFuelVendorAccount.vendor_name,
                batch: updatedFuelVendorAccount.batch,
                interactive: updatedFuelVendorAccount.interactive
            };
            updateFuelVendor(fuelUpdateObject);
        }
    };

    const closePopup = () => {
        setOpenConfimation(false);
        toggleDuplicateCheck(false);
    };

    const dialogAction = (
        <div>
            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME}>
                <Button component="span" onClick={() => closePopup()}>
                    OK
                </Button>
            </MuiThemeProvider>
        </div>
    );

    const cancelActions = (
        <div>
            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME}>
                <Button component="span" onClick={() => setOpenDialog(false)}>
                    No
                </Button>
            </MuiThemeProvider>
            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME}>
                <Button component="span" onClick={() => discardChanges()}>
                    Yes
                </Button>
            </MuiThemeProvider>
        </div>
    );

    const discardChanges = () => {
        resetToDefaults();
        if (!isBlank(fuelVendor.id)) {
            setFuelVendor({});
            setFuelVendor(fuelVendorAccount);
            updateFuelAccount(fuelVendorAccount);
            discardFuelChanges(true);
            setToggleEditFuelDetails(false);
            setFieldValidation({
                account_code: defErrorConfig,
                customer_code: defErrorConfig,
                user_name: defErrorConfig,
                password: defErrorConfig,
                integration_type: defErrorConfig
            });
        }
        if (isBlank(fuelVendor.id)) {
            setFuelVendor({});
            navigateToFuelSummary();
        }
    };

    const resetToDefaults = () => {
        setOpenDialog(false);
        toggleEditDetails(false);
        setToggleEditFuelDetails(false);
        setDisableSaveBtn(true);
        updateCreatedFuelVendorId('');
    };

    const handleEditClick = () => {
        setToggleEditFuelDetails(true);
    };

    const navigateToFuelSummary = () => {
        if (isSystemAdmin) {
            props.history.push(`/fuelcardpartners?accountId=${selectedAccount.id}`);
        } else {
            props.history.push(`/fuelcardpartners`);
        }
        if (!editDetails) {
            resetFuelVendorAccount({});
        }
    };

    const openAlert = () => {
        return !!(editDetails && !openDialog);
    };

    const disableButton = () => {
        if (isBlank(fuelVendor.id)) {
            return false;
        } else {
            return !!(isNotBlank(fuelVendor.id) && !toggleEditFuelDetails);
        }
    };

    const disableSave = () => {
        let fuelUpdateObject = {
            ...fuelVendor,
            vendor_name: updatedFuelVendorAccount.vendor_name,
            batch: updatedFuelVendorAccount.batch,
            interactive: updatedFuelVendorAccount.interactive
        };
        const isChanged = JSON.stringify(fuelVendorAccount) === JSON.stringify(fuelUpdateObject);
        const checkEmpty = checkEmptyFields(fuelUpdateObject, displayType, field);

        if (isChanged || checkEmpty) {
            setDisableSaveBtn(true);
        } else {
            setDisableSaveBtn(false);
        }
    };

    const handleClose = (event) => {
        const { value } = event.target;
        let event1 = { target: {} };
        event1.target.name = 'integration_type';
        event1.target.value = value ? value : '';
        if (!fuelVendor.integration_type) {
            validateFields(event1);
        }
    };

    const inputFields = (
        <MuiThemeProvider theme={FILLED_TEXTFIELD_THEME}>
            <React.Fragment>
                <React.Fragment>
                    <VendorNameSearch selectedFuelVendorId={selectedFuelVendorId} />
                </React.Fragment>
                <React.Fragment>
                    <div className={classes.togglePanel}>
                        <PrimarySwitch
                            id={'Fuel_Vendor_Status'}
                            name={'status'}
                            checked={fuelVendor.status}
                            onChange={(event) => handleChange(event)}
                            disabled={isBlank(selectedFuelVendorId) || disableButton()}
                            className="Switch-light-blue"
                        />
                        {fuelVendor.status ? 'ACTIVE' : 'INACTIVE'}
                    </div>
                </React.Fragment>
                <React.Fragment>
                    <Grid
                        container
                        justify={'space-between'}
                        direction={'row'}
                        className={classes.subType}
                    >
                        <Grid item>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Type</FormLabel>
                                <RadioGroup
                                    row
                                    justify={'space-between'}
                                    aria-label="vendor type"
                                    name="vendor_type"
                                    value={fuelVendor.vendor_type}
                                    onChange={(event) => handleChange(event)}
                                    id={'Fuel_Vendor_Type'}
                                >
                                    <FormControlLabel
                                        disabled={!isBlank(selectedFuelVendorId)}
                                        value={Constants.FUEL_VENDOR_BATCH_TYPE}
                                        control={<Radio />}
                                        label="Batch(FTP)"
                                        id={'Fuel_Vendor_Batch_Type'}
                                    />
                                    <FormControlLabel
                                        disabled={disableInteractiveField}
                                        value={Constants.FUEL_VENDOR_INTERACTIVE_TYPE}
                                        control={<Radio />}
                                        label="Interactive"
                                        id={'Fuel_Vendor_Interactive_Type'}
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>
                </React.Fragment>
                {displayType.comDataInteractive ? (
                    <React.Fragment>
                        <MuiThemeProvider theme={INTEGRATION_OPTIONS_THEME}>
                            <FormControl>
                                <InputLabel
                                    htmlFor="Integration-Type-label"
                                    shrink={
                                        isNotBlank(fuelVendor.integration_type)
                                            ? fuelVendor.integration_type.length > 0
                                            : false
                                    }
                                    error={field.integration_type.invalid}
                                >
                                    Integration Type*
                                </InputLabel>
                                <Select
                                    labelId="Integration-Type"
                                    id="integration_type"
                                    name="integration_type"
                                    required
                                    fullWidth
                                    variant={'standard'}
                                    input={
                                        <FilledInput
                                            name="Integration-Type"
                                            id="Integration-Type-label"
                                        />
                                    }
                                    value={fuelVendor.integration_type}
                                    onChange={(event) => handleChange(event)}
                                    onClose={(event) => handleClose(event)}
                                    renderValue={(selected) => selected}
                                    label={'Integration Type'}
                                    MenuProps={MenuProps}
                                    disabled={!isBlank(selectedFuelVendorId)}
                                >
                                    {Constants.INTEGRATION_OPTIONS.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText>{field.integration_type.message}</FormHelperText>
                            </FormControl>
                        </MuiThemeProvider>
                    </React.Fragment>
                ) : null}
                <React.Fragment>
                    <TextField
                        className={cs(classes.textField, classes.fieldWidth)}
                        required
                        label={'Account Code'}
                        name={'account_code'}
                        value={fuelVendor.account_code}
                        disabled={!toggleEditFuelDetails}
                        onChange={(event) => handleChange(event)}
                        onBlur={(event) => validateFields(event)}
                        error={field.account_code.invalid}
                        helperText={field.account_code.message}
                        id={'account_code'}
                        fullWidth
                        variant="filled"
                        margin="dense"
                    />
                </React.Fragment>
                <React.Fragment>
                    <TextField
                        className={cs(classes.textField, classes.fieldWidth)}
                        required
                        label={'Customer Code'}
                        name={'customer_code'}
                        value={fuelVendor.customer_code}
                        disabled={!toggleEditFuelDetails}
                        onChange={(event) => handleChange(event)}
                        onBlur={(event) => validateFields(event)}
                        error={field.customer_code.invalid}
                        helperText={field.customer_code.message}
                        id={'customer_code'}
                        fullWidth
                        variant="filled"
                        margin="dense"
                    />
                </React.Fragment>
                <React.Fragment>
                    <TextField
                        className={cs(classes.textField, classes.fieldWidth)}
                        required
                        label={'User Name'}
                        name={'user_name'}
                        value={fuelVendor.user_name}
                        disabled={!toggleEditFuelDetails}
                        onChange={(event) => handleChange(event)}
                        onBlur={(event) => validateFields(event)}
                        error={field.user_name.invalid}
                        helperText={field.user_name.message}
                        id={'user_name'}
                        fullWidth
                        variant="filled"
                        margin="dense"
                    />
                </React.Fragment>
                <React.Fragment>
                    <TextField
                        className={cs(classes.textField, classes.fieldWidth)}
                        required
                        label={'Password'}
                        name={'password'}
                        value={fuelVendor.password}
                        disabled={!toggleEditFuelDetails}
                        onChange={(event) => handleChange(event)}
                        onBlur={(event) => validateFields(event)}
                        error={field.password.invalid}
                        helperText={field.password.message}
                        id={'password'}
                        fullWidth
                        variant="filled"
                        margin="dense"
                    />
                </React.Fragment>
            </React.Fragment>
        </MuiThemeProvider>
    );

    return (
        <Auxiliary>
            <Auxiliary>
                <Header title="FUEL CARD DETAIL" />
                <MuiThemeProvider theme={!isSystemAdmin ? APP_BAR_THEME : APP_BAR_THEME_ALT}>
                    <AppBar position={'static'}>
                        <Grid container direction={'row'}>
                            <Grid item xs={5}>
                                <div
                                    className={classes.backIcon}
                                    onClick={() => navigateToFuelSummary()}
                                    id={'BACK_TO_FUEL_CARD_PARTNERS'}
                                >
                                    <i
                                        className={cs(
                                            'fas fa-arrow-left',
                                            baseCSS.backNavigationIcon
                                        )}
                                    />
                                    <label className={baseCSS.backNavigation}>
                                        BACK TO FUEL CARD PARTNERS
                                    </label>
                                </div>
                            </Grid>
                            <Grid item xs={7}>
                                <label className={classes.AppHeaderText}>
                                    {isSystemAdmin ? selectedAccount.name : session.accountName}
                                </label>
                            </Grid>
                        </Grid>
                    </AppBar>
                </MuiThemeProvider>
            </Auxiliary>
            {!showSpinner ? (
                <div className={cs(Styles.baseMargin, isSystemAdmin && Styles.customRoot)}>
                    <MuiThemeProvider theme={FILLED_INPUT_FIELD_THEME}>
                        <Paper elevation={0}>
                            <div className={cs('row')}>
                                <div className={cs('col-md-4', Styles.baseHeight)}>
                                    <Paper className={Styles.baseMargin} elevation={0}>
                                        <Grid container justify={'space-between'}>
                                            <Grid item>
                                                <div
                                                    className={Styles.fuelVendorDetailsPanelHeader}
                                                >
                                                    FUEL CARD PARTNER
                                                </div>
                                            </Grid>
                                            <Grid item>
                                                {!toggleEditFuelDetails && (
                                                    <IconButton
                                                        id={'editIcon'}
                                                        size="small"
                                                        disabled={!isWriteAccessGranted}
                                                        onClick={() => handleEditClick()}
                                                    >
                                                        <CreateIcon fontSize="small" />
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        </Grid>
                                        {inputFields}
                                    </Paper>
                                </div>
                                <div
                                    className={cs(
                                        'col-md-8',
                                        Styles.propertiesPanel,
                                        Styles.defaultHeight
                                    )}
                                >
                                    <Paper elevation={0}>
                                        {displayType.batchType ? (
                                            <BatchType
                                                toggleEditFuelDetails={toggleEditFuelDetails}
                                            />
                                        ) : null}
                                        {displayType.interactive ||
                                        displayType.comDataInteractive ? (
                                            <InteractiveType
                                                toggleEditFuelDetails={toggleEditFuelDetails}
                                                displayType={displayType}
                                            />
                                        ) : null}
                                    </Paper>
                                    <div className="text-right">
                                        <MuiThemeProvider
                                            theme={PRIMARY_BUTTON_LIGHT_NEGATIVE_THEME}
                                        >
                                            <Button
                                                id={'cancel'}
                                                size="small"
                                                disabled={!isWriteAccessGranted}
                                                onClick={() => setOpenDialog(true)}
                                            >
                                                Cancel
                                            </Button>
                                        </MuiThemeProvider>
                                        <MuiThemeProvider theme={PRIMARY_BUTTON_LIGHT_THEME}>
                                            <Button
                                                id={'save'}
                                                size="small"
                                                color="primary"
                                                disabled={
                                                    disableSaveBtn ||
                                                    disableSaveButton ||
                                                    !toggleEditFuelDetails
                                                }
                                                onClick={() => handleSave()}
                                            >
                                                Save
                                            </Button>
                                        </MuiThemeProvider>
                                    </div>
                                </div>
                            </div>
                        </Paper>
                    </MuiThemeProvider>
                </div>
            ) : (
                <Spinner />
            )}
            {isDuplicateFuelVendor ? (
                <MuiThemeProvider theme={DIALOG_THEME}>
                    <TDialog
                        id={'duplicate_entry'}
                        open={openConfimation}
                        handleClose={() => setOpenConfimation(false)}
                        dialogContentText={duplicateVendorText}
                        dialogTitle={'Duplicate Entry'}
                        dialogActions={dialogAction}
                    />
                </MuiThemeProvider>
            ) : null}
            <TDialog
                id={'cancel_changes'}
                open={openDialog}
                handleClose={() => setOpenDialog(false)}
                dialogContentText={'Are you sure you want to cancel these changes?'}
                dialogTitle={'Confirmation'}
                dialogActions={cancelActions}
            />
            {showSpinner && <Spinner />}
            {
                <Prompt
                    when={openAlert()}
                    message="Are you sure you want to navigate to away from this page without saving your changes?"
                />
            }
        </Auxiliary>
    );
};

const mapStateToProps = (state) => {
    return {
        sidebarResource: state.header.sidebarResource,
        session: state.session.sessionValue,
        fuelVendorAccount: state.fuelVendor.fuelVendorAccount,
        isDuplicateFuelVendor: state.fuelVendor.isDuplicateFuelVendor,
        createdFuelVendorID: state.fuelVendor.createdFuelVendorID,
        isFuelVendorDetailsLoaded: state.fuelVendor.isFuelVendorDetailsLoaded,
        showSpinner: state.fuelVendor.showSpinner,
        updatedFuelVendorAccount: state.fuelVendor.updatedFuelVendorAccount,
        isFuelVendorNamesLoaded: state.fuelVendor.isFuelVendorNamesLoaded,
        fuelVendorNames: state.fuelVendor.fuelVendorNames,
        disableInteractiveField: state.fuelVendor.disableInteractiveField,
        disableSaveButton: state.fuelVendor.disableSaveButton,
        editDetails: state.fuelVendor.editDetails,
        selectedAccount: state.accounts.selectedAccount
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFuelVendorAccount: (accountId) => dispatch(actions.getFuelVendorAccount(accountId)),
        updateFuelAccount: (account) => dispatch(actions.updateFuelAccount(account)),
        saveFuelVendor: (account) => dispatch(actions.saveFuelVendor(account)),
        updateFuelVendor: (account) => dispatch(actions.updateFuelVendor(account)),
        toggleDuplicateCheck: (flag) => dispatch(actions.toggleDuplicateCheck(flag)),
        updateCreatedFuelVendorId: (id) => dispatch(actions.updateCreatedFuelVendorId(id)),
        toggleFuelDetailsLoaded: (flag) => dispatch(actions.toggleFuelDetailsLoaded(flag)),
        toggleFuelVendorStatus: (vendorsList, flag) =>
            dispatch(actions.toggleFuelVendorStatus(vendorsList, flag)),
        toggleSpinner: (flag) => dispatch(actions.toggleSpinner(flag)),
        discardFuelChanges: (flag) => dispatch(actions.discardFuelChanges(flag)),
        toggleSaveButton: (flag) => dispatch(actions.toggleSaveButton(flag)),
        setCurrentPage: (pageName) => dispatch(setCurrentPage(pageName)),
        resetFuelVendorAccount: (account) => dispatch(actions.resetFuelVendorAccount(account)),
        toggleEditDetails: (flag) => dispatch(actions.toggleEditDetails(flag))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FuelVendorDetails));
